import { useCaseViewStyle } from "../../components/CaseView/useCaseViewStyle";
import { tokens } from "../../theme/tokens";

import CaseInformationSection from "../../components/CaseView/CaseDetails/CaseInformationSection";
import ReferralNotesSection from "../../components/CaseView/CaseDetails/ReferralNotesSection";
import BudgetSection from "../../components/CaseView/CaseDetails/BudgetSection";
import TasksSection from "../../components/CaseView/CaseDetails/TasksSection";
import ClientInformationSection from "../../components/CaseView/CaseDetails/ClientInformationSection";
import FieldResourceSection from "../../components/CaseView/CaseDetails/FieldResourceSection";

function CaseDetailsTab() {
  const classes = useCaseViewStyle();

  return (
    <div style={{ padding: tokens.space[4] }}>
      <div className={classes.cardContainer}>
        {/* Left Column */}
        <div
          className={classes.tabContainers}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <CaseInformationSection />
          <ReferralNotesSection />
          <BudgetSection />
        </div>

        {/* Right Column */}
        <div
          className={classes.tabContainers}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "inherit",
          }}
        >
          <TasksSection />
          <ClientInformationSection />
          <FieldResourceSection />
        </div>
      </div>
    </div>
  );
}

export default CaseDetailsTab;
